module.exports = __webpack_public_path__ + "img/img_logo_extra.79b9f885.svg";